const noResultsDataPush = (dateRange: string) => {
  //@ts-ignore
  if (window.digitalData) {
    let result = {
      event: { name: "error" },
      error: {
        type: "search",
        message: `you do not have any purchases in the last ${dateRange.toLowerCase()}`,
      },
    };
    //@ts-ignore
    return digitalData.push(result);
  }
};

export default noResultsDataPush;
